import { render, staticRenderFns } from "./XRadio.vue?vue&type=template&id=260c59ba&scoped=true"
import script from "./XRadio.vue?vue&type=script&lang=js"
export * from "./XRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c59ba",
  null
  
)

export default component.exports